import {
  Bell,
  Blocks,
  FileText,
  FolderKanban,
  LayoutDashboard,
  MessageSquare,
  Settings2,
} from 'lucide-react';

export interface NavSubItem {
  title: string;
  url: string;
  isActive: boolean;
}

export interface NavItem {
  title: string;
  url: string;
  icon: any;
  isActive: boolean;
  items?: NavSubItem[];
}

/** Translator for the `navigation` namespace (react-i18next `t`). */
type NavTranslator = (key: string) => string;

export const createNavConfig = (
  selectedWorkspaceId: string,
  currentPath: string,
  hasProjects: boolean,
  projectExists: boolean,
  selectedProjectId: string | number | null,
  t: NavTranslator
) => {
  const reportsUrl =
    hasProjects && selectedProjectId
      ? `/${selectedWorkspaceId}/reports/${selectedProjectId}`
      : `/${selectedWorkspaceId}/reports`;

  // Base menu items for all users
  const userNavItems: NavItem[] = [
    {
      title: t('dashboard'),
      url: `/${selectedWorkspaceId}`,
      icon: LayoutDashboard,
      isActive: currentPath === `/${selectedWorkspaceId}`,
    },
  ];

  // Extended menu items for administrator
  const adminNavItems: NavItem[] = [
    ...userNavItems,
    {
      title: t('projects'),
      url: `/${selectedWorkspaceId}/projects`,
      icon: FolderKanban,
      isActive: currentPath.startsWith(`/${selectedWorkspaceId}/projects`),
    },
    {
      title: t('reports'),
      url: reportsUrl,
      icon: FileText,
      isActive: currentPath.startsWith(`/${selectedWorkspaceId}/reports`),
    },
    {
      title: t('alerts'),
      url: `/${selectedWorkspaceId}/alerts`,
      icon: Bell,
      isActive: currentPath.startsWith(`/${selectedWorkspaceId}/alerts`),
    },
    {
      title: t('chat'),
      url: `/${selectedWorkspaceId}/chat`,
      icon: MessageSquare,
      isActive: currentPath.startsWith(`/${selectedWorkspaceId}/chat`),
    },
    {
      title: t('integrations'),
      url: `/${selectedWorkspaceId}/integrations`,
      icon: Blocks,
      isActive: currentPath.startsWith(`/${selectedWorkspaceId}/integrations`),
    },
    {
      title: t('settings'),
      url: `/${selectedWorkspaceId}/settings`,
      icon: Settings2,
      isActive: currentPath.startsWith(`/${selectedWorkspaceId}/settings`),
      items: [
        {
          title: t('profile'),
          url: `/${selectedWorkspaceId}/settings/profile`,
          isActive: currentPath === `/${selectedWorkspaceId}/settings/profile`,
        },
        {
          title: t('workspace'),
          url: `/${selectedWorkspaceId}/settings/workspace`,
          isActive: currentPath === `/${selectedWorkspaceId}/settings/workspace`,
        },
        {
          title: t('members'),
          url: `/${selectedWorkspaceId}/settings/members`,
          isActive: currentPath === `/${selectedWorkspaceId}/settings/members`,
        },
      ],
    },
  ];

  return {
    userNavItems,
    adminNavItems,
  };
};
